
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/apps",
      function () {
        return require("private-next-pages/android/local/apps/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/apps"])
      });
    }
  